import script from "./TypeAhead.vue?vue&type=script&lang=ts&setup=true"
export * from "./TypeAhead.vue?vue&type=script&lang=ts&setup=true"

import "./TypeAhead.vue?vue&type=style&index=0&id=5f37ac56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f37ac56"]])

export default __exports__